import React from "react";
import "./Toast.scss";
import { closeAlert } from "../../actions/crossSellApplicationActions";
import { connect } from "react-redux";
export class Toast extends React.Component{
  state= { title: "", description: "", alertType: "" };
  componentWillMount() {
    let data = this.props;
    this.setState({ ...data });
    //setTimeout(this.onClose, 10000);
  }
onClose=()=>{
  this.props.closeAlert(false);
};
render(){
  const classes = `alert alert-dismissible alert-${this.state.alertType}`;
  return (
    <div className="alert-box">
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col col-lg-10 col-md-11 col-sm-12">
            <div className={classes} >
              <button onClick={this.onClose} type="button" className="close" data-dismiss="alert" >&times;</button>
              <div className="row justify-content-start no-wrap">
                <div className="left-box"> <span className="clapply-icon exclamation-mark">&#9432;</span></div>
                <div className="right-box">
                  <strong className="alert-heading">{this.state.title}</strong>
                  <p className="alert-body">{this.state.description} </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
}
const mapDispatchToProps = { closeAlert: closeAlert };
export default connect(null, mapDispatchToProps)(Toast);
